import * as segmentio from 'rp-analytics';
import jQuery from 'jquery';
import { isDamHorseProfile } from './utils/isDamHorseProfile';

const section1 = {
    horse: 'Horses',
    jockey: 'Jockeys',
    owner: 'Owners',
    trainer: 'Trainers',
    course: 'Courses',
};

const state = {
    raceHorseName: '',
    jokeyName: '',
    ownerName: '',
    trainerName: '',
    courseName: '',
};

export const getHorseName = () => state.raceHorseName;

export default function analyticsPage(preloadedState = false, hasAccess = null) {
    const pathnameSplit = global.location.pathname.split('/');
    const type = pathnameSplit[2];
    // eslint-disable-next-line

    if (preloadedState) {
        state.raceHorseName = type === 'horse' &&
            preloadedState.profile &&
            preloadedState.profile.horseName;

        state.jokeyName = type === 'jockey' &&
            preloadedState.profile &&
            preloadedState.profile.styleName;

        state.ownerName = type === 'owner' &&
            preloadedState.profile &&
            preloadedState.profile.styleName;

        state.trainerName = type === 'trainer' &&
            preloadedState.profile &&
            preloadedState.profile.styleName;

        state.courseName = type === 'course' &&
            preloadedState.profile &&
            preloadedState.profile.courseStyleName;
    }

    /*
        These constants for sections are for the bloodstock horse profile logic JP-9373
        where we have to add site_sub_section_3 in the analytics for the bloodstock horse profile on Stub Record and Sales Record tabs.
     */
    const newSection2 = jQuery('span.ui-tabs__tab_selected').attr('data-tab-name');
    const newSection3 = jQuery('.pp-subTabs__tab_selected').text();

    const commonTraits = segmentio.getCommonTraits();

    const oldSection2 = commonTraits && commonTraits[segmentio.TRAIT_SITE_SUB_SECTION_2];
    const oldSection3 = commonTraits && commonTraits[segmentio.TRAIT_SITE_SUB_SECTION_3];

    const shouldIncludeSectionThree =
        newSection2 === 'Stud Record' || newSection2 === 'Sales Record';
    const hasSectionThree = newSection3 !== '' && newSection3 !== oldSection3;

    const hasSectionTwo = newSection2 && newSection2 !== oldSection2;
    const isDamProfile = isDamHorseProfile();

    if (!hasSectionTwo && !hasSectionThree && !isDamProfile) {
        return;
    }

    const subsection = localStorage.getItem('subsection');

    segmentio.clearCommonTraits();
    const commonTraitsProps = {
        [segmentio.TRAIT_SITE_SECTION]: 'Profiles',
        [segmentio.TRAIT_SITE_SUB_SECTION_1]: section1[type],
        [segmentio.TRAIT_SITE_SUB_SECTION_2]: newSection2,
        ...(subsection && { [segmentio.TRAIT_SUBSECTION]: subsection }),
    };

    if (shouldIncludeSectionThree) {
        segmentio.setCommonTraits({
            ...commonTraitsProps,
            [segmentio.TRAIT_SITE_SUB_SECTION_3]: newSection3,
        });
    } else {
        segmentio.setCommonTraits({
            ...commonTraitsProps,
        });
    }

    const pageTraits = {};

    if (state.raceHorseName) {
        pageTraits['race_horse_name'] = state.raceHorseName; // eslint-disable-line
    }

    if (state.jokeyName) {
        pageTraits['jockey_name'] = state.jokeyName;// eslint-disable-line
    }

    if (state.ownerName) {
        pageTraits['owner_name'] = state.ownerName;// eslint-disable-line
    }

    if (state.trainerName) {
        pageTraits['trainer_name'] = state.trainerName;// eslint-disable-line
    }

    if (state.courseName) {
        pageTraits['course_name'] = state.courseName;// eslint-disable-line
    }

    if (hasAccess !== null) {
        pageTraits.paywall_barrier = hasAccess;// eslint-disable-line
    }
    pageTraits.title = window.pageTitle;

    // For proper ad triggering on Dam profiles [JP-10859]
    let eventName = window.location.pathname;

    if (eventName.endsWith('/') && eventName.length > 1 && isDamProfile) {
        eventName = eventName.slice(0, -1);
    }

    segmentio.page(eventName, pageTraits, segmentio.page.DEFAULT_OPTIONS);
}



// WEBPACK FOOTER //
// ./src/js/analyticsPage.js